import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import DeleteSystemUser from './DeleteSystemUser';
import AddSystemUser from './AddSystemUser';
import UpdateSystemUser from './UpdateSystemUser';
import MessageBox from "../../../components/MessageBox/MessageBox";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const SystemUser = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [downloadFlag, setDownloadFlag] = useState(false);
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	const [canAddUser, setCanAddUsers] = useState(true);
	const [canViewUser,setCanViewUser] = useState(false);
	//Message Box EOF

	useEffect(() => {
		const raw = get_cookies('position_id');

		const cleaned = raw.replace(/^"(.*)"$/, '$1');
		if( Number(cleaned) === 1){
			setCanViewUser(true);
		}else{
			setCanViewUser(false);
		}
	
	}, []);
	// Data Fetching
	useEffect(() => {
		data();
	
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
			checkUserStatus();
		dataFilter();
		get_count_user();
	}, [x]);


	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
		const checkUserStatus = async () => {
        	await axios.post(
            process.env.REACT_APP_API_URL+'checkUserStatus', {
			}).then(function (res) {
				  if(!res.data.success){
      				window.location.replace(process.env.REACT_APP_BASE_URL+"/settings");
  				}

		  	}).catch(function (error) {	
				console.log(error);
	 });

    }

	//search button
	const dataFilter = async () => {
        	await axios.get(
            process.env.REACT_APP_API_URL+'get_system_users', {
				params:{
					position_id: get_cookies('position_id'), //pass the main_nav_id from cookies to get data from api param example: "1,2,3,4,5,6,7,8"
					branchidno: get_cookies('branchidno'),//pass the idno to get only the same idno of users
				}
			}).then(function (res) {
				setPosts(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	 });

    }
    	 const get_count_user = async () => {
        	await axios.get(
            process.env.REACT_APP_API_URL+'get_system_users_count', {
				params:{
					position_id: get_cookies('position_id'), //pass the main_nav_id from cookies to get data from api param example: "1,2,3,4,5,6,7,8"
					branchidno: get_cookies('branchidno'),//pass the idno to get only the same idno of users
				}
			}).then(function (res) {
				setCanAddUsers(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	 });
	}

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const showModal = (message, type) => {
		setDataLoaded(false);
			setShowMsgBox(true);
			setMsgType(type); //success or warning
			setMsg(message);
			dataFilter();
			get_count_user();
			setTimeout(() => {
				setShowMsgBox(false);
				dataFilter();
				setDataLoaded(true);
			}, 2000)
	};

	const getMuiTheme = () => createMuiTheme({
		overrides: {
		  MUIDataTableHeadCell: {
			root: {
			  '&:nth-child(1)': {
					width: 600
				  },	
			  '&:nth-child(2)': {
				width: 600
			  },
			  '&:nth-child(3)': {
				width: 250
			  },
			}
		  }
		}
	  });

	const columns = [
		{
			name: "position",
			label: "Position",
		},
		{
			name: "user_fullname",
			label: "Full Name",
		},
		{
			name: "user_fullname",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let user_id = posts[dataIndex].id;
					let user_fullname = posts[dataIndex].user_fullname;
					let user_details = 
						{
							name : posts[dataIndex].user_fullname,
							username : posts[dataIndex].username,
							branchidno : posts[dataIndex].idno,
							position : posts[dataIndex].position,
							position_id : posts[dataIndex].access,
						};
                            return (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={6} lg={5} xl={4} key={user_fullname}>
										   <UpdateSystemUser user_id={user_id} user_details={user_details} showModal={showModal}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={5} xl={4} key={user_fullname+user_id}>
										   <DeleteSystemUser user_id={user_id} user_fullname={user_fullname} showModal={showModal}/>
                                    </Grid>
                                </Grid>
                            );
			  },
			  download: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: false,
		filterType: "nne",
		selectableRows: "none",
		// filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},downloadOptions: {
			filename : 'SystemUser.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		// marginTop:"2.5em",
	};

	return (
		<div className="page">
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/settings"}><h4 style={{color:"#339933"}}>Settings</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>User Management</h4>
			</div>

			{canViewUser?
						<div className="page-container">
													<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} xl={12} style={{ display: "flex", justifyContent: "flex-end" }}>
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button> */}
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Add Role</Button> */}
							{canAddUser == true?get_cookies('position_id') != 0 && get_cookies('position_id') != 1?<AddSystemUser showModal={showModal}/>:null:null}
							
						
						</Grid>
					</Grid>     
					  
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<>

	
									<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Users
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
					</MuiThemeProvider>
					</>

				)}
			</div>
			: null}

		</div>
	);
};

export default SystemUser;
